import {
  blog,
  blog1,
  blog2,
  blog3,
  blog4,
  blog5,
  blog6,
  blog7, 
} from '../../../../../images/index.js'

export const images = [blog1, blog2, blog3, blog6 , blog5,blog7, blog6, blog4,];
export const blogs = [
  {
    id: "1",
    image: blog,
    title: "From Chaos to Clarity: How Data...",
    subtitle: "E-commerce brands are drowning in dashboards, numbers, and endless reports yet starving for c...",
    content: `We’re on a mission to simplify online selling. Sell light employees access to track, manage, and grow their marketplace...`,
  },
  {
    id: "2",
    image: blog,
    title: "Grow Your Marketplace",
    subtitle: "Track, manage, and scale all in one place.",
    content: `Using the dashboard, your team can track everything efficiently...`,
  },
  {
    id: "3",
    image: blog,
    title: "E-Commerce Dashboard Insights",
    subtitle: "Powerful analytics to monitor your marketplace growth.",
    content: `Access visual reports and charts to understand your business better...`,
  },
  // {
  //   id: "4",
  //   image: blog4,
  //   title: "Smart Business Solutions",
  //   subtitle: "Automate your sales and inventory in one dashboard.",
  //   content: `Automate routine operations with powerful built-in tools...`,
  // },
  // {
  //   id: "5",
  //   image: blog5,
  //   title: "Customizable Analytics",
  //   subtitle: "Tailor dashboards for sellers and buyers.",
  //   content: `Set filters, view patterns, and optimize performance in real-time...`,
  // },
  // {
  //   id: "6",
  //   image: blog6,
  //   title: "Seamless User Interface",
  //   subtitle: "Simplified navigation for better user retention.",
  //   content: `Easy-to-use UI helps reduce bounce rates and improve conversions...`,
  // },
  // {
  //   id: "7",
  //   image: blog7,
  //   title: "Data That Drives Decisions",
  //   subtitle: "Leverage insights to boost your strategy.",
  //   content: `Convert data into actionable steps with our strategic dashboard...`,
  // },
  // {
  //   id: "8",
  //   image: blog1,
  //   title: "All-in-One Business Toolkit",
  //   subtitle: "Run your marketplace effortlessly with our solution.",
  //   content: `No need for third-party tools our platform does it all...`,
  // },
];
 export const articles = [
    {
      date: "Nov 01, 2022",
      title: "From Chaos to Clarity",
      image:blog,
      desc: "E-commerce brands are drowning in dashboards, numbers, and data noise.",
    },
    {
      date: "Nov 01, 2022",
      title: "From Chaos to Clarity",
      image:blog,
      desc: "E-commerce brands are drowning in dashboards, numbers, and data noise.",
    },
    {
      date: "Nov 01, 2022",
      title: "From Chaos to Clarity",
      image:blog,
      desc: "E-commerce brands are drowning in dashboards, numbers, and data noise.",
    },
  ];